export const CrashMe = () => {
  throw new Error('This is a Crash Me page');
};
